/* ELEGANT STYLE — Ficha de producto: selector de color/talla, video en bucle, precio por cantidad, agregar al carrito/WhatsApp */
(function () {
  'use strict';
  var dataEl = document.getElementById('ec-product-data');
  if (!dataEl) return;
  var P;
  try { P = JSON.parse(dataEl.textContent); } catch (e) { return; }

  var state = {
    colorIdx: 0,
    talla: P.tallas && P.tallas.length ? P.tallas[0] : null,
    qty: 0,
  };

  function fmt(n) {
    var cfg = window.ECConfig || { moneda: 'S/' };
    return cfg.moneda + ' ' + (Math.round(n * 100) / 100).toFixed(2);
  }

  function tierFor(tiers, qty) {
    if (!tiers || !tiers.length) return null;
    var t = tiers[0];
    for (var i = 0; i < tiers.length; i++) { if (qty >= tiers[i].qty) t = tiers[i]; }
    return t;
  }

  /* Soporta dos formatos para custom.tiers:
     - Array plano: [{qty,price}, ...] -> mismos precios para todas las tallas (ej. Jogger), el
       recargo por talla se maneja aparte con custom.size_extra.
     - Objeto por talla: {"S":[{qty,price}...], "XL":[{qty,price}...]} -> precios ya incluyen
       cualquier diferencia por talla, no se aplica size_extra encima. */
  function getSizeTiers() {
    if (!P.tiers) return null;
    if (Array.isArray(P.tiers)) return P.tiers;
    if (state.talla && P.tiers[state.talla]) return P.tiers[state.talla];
    var firstKey = Object.keys(P.tiers)[0];
    return firstKey ? P.tiers[firstKey] : null;
  }

  function currentColorName() {
    return P.hasColor && P.colors && P.colors.length ? P.colors[state.colorIdx] : null;
  }

  function findVariant(colorName, tallaName) {
    return P.variants.find(function (v) {
      var cOk = !P.hasColor || v.color === colorName;
      var tOk = !P.hasTalla || v.talla === tallaName;
      return cOk && tOk;
    });
  }

  function currentImages() {
    var colorName = currentColorName();
    if (P.colorImages && colorName && P.colorImages[colorName]) return P.colorImages[colorName];
    var v = findVariant(colorName, state.talla);
    if (v && v.image) return [v.image];
    if (P.featuredImage) return [P.featuredImage];
    return [];
  }
  function currentVideo() {
    var colorName = currentColorName();
    if (P.colorVideos && colorName && P.colorVideos[colorName]) return P.colorVideos[colorName];
    return null;
  }

  function renderGallery() {
    var imgs = currentImages();
    var video = currentVideo();
    var mainImg = document.getElementById('ec-main-image');
    var mainVideo = document.getElementById('ec-main-video');
    var thumbs = document.getElementById('ec-thumbs');

    if (imgs.length) { mainImg.src = imgs[0]; mainImg.style.display = 'block'; }
    mainVideo.style.display = 'none';
    mainVideo.pause();

    thumbs.innerHTML = imgs.map(function (src, i) {
      return '<img src="' + src + '" class="' + (i === 0 ? 'ec-active' : '') + '" data-idx="' + i + '">';
    }).join('') + (video ? '<img src="' + (imgs[0] || '') + '" data-video="1" style="border:2px dashed #241F1A;" title="Ver video">' : '');

    Array.prototype.forEach.call(thumbs.querySelectorAll('img'), function (t) {
      t.addEventListener('click', function () {
        Array.prototype.forEach.call(thumbs.querySelectorAll('img'), function (x) { x.classList.remove('ec-active'); });
        if (t.dataset.video) {
          mainVideo.src = video;
          mainVideo.style.display = 'block';
          mainImg.style.display = 'none';
          mainVideo.play();
        } else {
          mainVideo.style.display = 'none';
          mainVideo.pause();
          mainImg.style.display = 'block';
          mainImg.src = imgs[parseInt(t.dataset.idx, 10)];
          t.classList.add('ec-active');
        }
      });
    });
  }

  function renderSwatches() {
    var wrap = document.getElementById('ec-color-swatches');
    if (!wrap) return;
    document.getElementById('ec-color-label').textContent = currentColorName() || '';
    wrap.innerHTML = P.colors.map(function (c, i) {
      var thumb = (P.colorImages && P.colorImages[c] && P.colorImages[c][0]) || P.featuredImage || '';
      return '<div class="ec-swatch ' + (i === state.colorIdx ? 'ec-active' : '') + '" data-idx="' + i + '" title="' + c + '"><img src="' + thumb + '"></div>';
    }).join('');
    Array.prototype.forEach.call(wrap.querySelectorAll('.ec-swatch'), function (el) {
      el.addEventListener('click', function () {
        state.colorIdx = parseInt(el.dataset.idx, 10);
        renderSwatches();
        renderGallery();
        renderPrice();
      });
    });
  }

  function renderTallas() {
    var wrap = document.getElementById('ec-talla-buttons');
    if (!wrap) return;
    wrap.innerHTML = P.tallas.map(function (t) {
      return '<button type="button" class="ec-talla-btn ' + (t === state.talla ? 'ec-active' : '') + '" data-talla="' + t + '">' + t + '</button>';
    }).join('');
    Array.prototype.forEach.call(wrap.querySelectorAll('.ec-talla-btn'), function (btn) {
      btn.addEventListener('click', function () {
        state.talla = btn.dataset.talla;
        renderTallas();
        renderPrice();
      });
    });
  }

  function sizeExtra() {
    if (!Array.isArray(P.tiers)) return 0; // el extra por talla ya está incluido en tiers-por-talla
    if (!P.sizeExtra || !state.talla) return 0;
    return P.sizeExtra[state.talla] || 0;
  }

  function unitPrice() {
    if (P.hasTiers) {
      var tiersArr = getSizeTiers();
      if (tiersArr && tiersArr.length) {
        var tier = tierFor(tiersArr, Math.max(state.qty, 1));
        return tier.price + sizeExtra();
      }
    }
    var v = findVariant(currentColorName(), state.talla);
    return v ? v.price : (P.variants[0] ? P.variants[0].price : 0);
  }

  function renderPrice() {
    var priceEl = document.getElementById('ec-price');
    var tiersArr = P.hasTiers ? getSizeTiers() : null;
    var base = tiersArr && tiersArr.length ? tiersArr[0].price + sizeExtra() : unitPrice();
    var price = unitPrice();
    if (price < base) {
      priceEl.innerHTML = fmt(price) + ' <span style="text-decoration:line-through;color:#999;font-weight:400;font-size:14px;">' + fmt(base) + '</span> <span style="color:#1a7a3a;font-size:13px;">c/u por mayor</span>';
    } else {
      priceEl.textContent = fmt(price) + ' c/u';
    }
  }

  function renderQuickAdd() {
    var wrap = document.getElementById('ec-quickadd');
    var packs = P.quickAdd && P.quickAdd.length ? P.quickAdd : [6, 12, 24];
    wrap.innerHTML = packs.map(function (n) { return '<button type="button" data-pack="' + n + '">+' + n + '</button>'; }).join('');
    Array.prototype.forEach.call(wrap.querySelectorAll('button'), function (btn) {
      btn.addEventListener('click', function () {
        state.qty += parseInt(btn.dataset.pack, 10);
        document.getElementById('ec-qty-input').value = state.qty;
        renderPrice();
      });
    });
  }

  function currentThumb() {
    var imgs = currentImages();
    return imgs.length ? imgs[0] : (P.featuredImage || '');
  }

  function buildCartItem() {
    var v = findVariant(currentColorName(), state.talla);
    /* Se resuelve tiers al array plano que aplica a la talla seleccionada, para que el
       carrito (ec-cart.js) siga funcionando sin cambios sin importar si el producto usa
       tiers planos (Jogger) o tiers por talla (Poleras). */
    var tiersArr = P.hasTiers ? getSizeTiers() : null;
    return {
      handle: P.handle,
      productTitle: P.title,
      productUrl: P.url,
      colorName: currentColorName(),
      talla: state.talla,
      img: currentThumb(),
      qty: state.qty,
      price: unitPrice(),
      tiers: tiersArr,
      sizeExtra: sizeExtra(),
      sku: v ? v.sku : null,
    };
  }

  document.getElementById('ec-qty-input') && (function () {
    var input = document.getElementById('ec-qty-input');
    document.querySelector('[data-ec-qty="inc"]').addEventListener('click', function () {
      state.qty += 1; input.value = state.qty; renderPrice();
    });
    document.querySelector('[data-ec-qty="dec"]').addEventListener('click', function () {
      state.qty = Math.max(0, state.qty - 1); input.value = state.qty; renderPrice();
    });
  })();

  var addBtn = document.getElementById('ec-add-cart');
  var buyBtn = document.getElementById('ec-buy-now');
  if (addBtn) addBtn.addEventListener('click', function () {
    if (state.qty <= 0) { alert('Elige una cantidad mayor a 0.'); return; }
    window.ECCart.addToCart(buildCartItem());
    window.ECCart.openDrawer();
  });
  if (buyBtn) buyBtn.addEventListener('click', function () {
    if (state.qty <= 0) { alert('Elige una cantidad mayor a 0.'); return; }
    window.ECCart.addToCart(buildCartItem());
    window.ECCart.openShipping();
  });

  if (P.hasColor) renderSwatches();
  if (P.hasTalla) renderTallas();
  renderGallery();
  renderPrice();
  renderQuickAdd();
})();
